function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPromoCash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30"
  }, props), /*#__PURE__*/React.createElement("g", {
    color: "#000",
    fontWeight: 400,
    fontFamily: "sans-serif",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      lineHeight: "normal",
      fontVariantLigatures: "none",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontFeatureSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      blockProgression: "tb",
      whiteSpace: "normal",
      shapePadding: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: 1
    },
    d: "M1.87.877a.99.99 0 00-.99.993l.012 13.004a.99.99 0 00.29.699l13.393 13.394a.99.99 0 001.4 0l12.991-12.992a.99.99 0 000-1.4L15.57 1.181a.99.99 0 00-.699-.29L1.87.876zm.99 1.98l11.602.013 12.403 12.406-11.591 11.59L2.87 14.462 2.86 2.857z",
    overflow: "visible"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      lineHeight: "normal",
      fontVariantLigatures: "none",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontFeatureSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      blockProgression: "tb",
      whiteSpace: "normal",
      shapePadding: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: 1
    },
    d: "M9.523 5.47A4.068 4.068 0 005.47 9.524a4.068 4.068 0 004.053 4.052 4.068 4.068 0 004.052-4.052A4.068 4.068 0 009.523 5.47zm0 1.98c1.156 0 2.072.917 2.072 2.073a2.058 2.058 0 01-2.072 2.072A2.058 2.058 0 017.45 9.523c0-1.156.917-2.073 2.073-2.073z",
    overflow: "visible"
  })));
}
export default "data:image/svg+xml;base64,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";
export { SvgIconPromoCash as ReactComponent };